import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

export default function DemoVideoPlayer({ src = '/videos/udvega-promo.mp4' }) {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }, []);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    const next = !muted;
    video.muted = next;
    setMuted(next);
    if (!next) {
      video.play().catch(() => {});
    }
  };

  return (
    <div
      className="relative w-full rounded-2xl md:rounded-3xl overflow-hidden border border-white/15 bg-slate-950 shadow-[0_24px_80px_-24px_rgba(13,148,136,0.45)] ring-1 ring-teal-400/20"
      data-testid="hero-demo-video"
    >
      <div className="absolute -inset-px rounded-2xl md:rounded-3xl pointer-events-none bg-gradient-to-br from-teal-400/25 via-transparent to-emerald-500/10" />
      <div className="relative aspect-video bg-slate-950">
        <video
          ref={videoRef}
          className="w-full h-full object-cover"
          src={src}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="60-second Udvega product demo of the AI burnout analytics dashboard"
        >
          Your browser does not support the video tag.
        </video>
        <button
          type="button"
          onClick={toggleMute}
          className="absolute bottom-3 right-3 z-10 h-9 w-9 rounded-full bg-slate-900/70 text-white border border-white/20 flex items-center justify-center hover:bg-slate-900/90"
          aria-label={muted ? 'Unmute demo video' : 'Mute demo video'}
        >
          {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
}
